import { Store } from 'laco'

const ReportSorting = new Store({})

export default ReportSorting
